var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwipeNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15C0 11.216 2.359 5 14.42 4.226V.694c0-.28-.143-.534.124-.641.089-.035.024-.053.115-.053.186 0 .29.07.426.203l6.726 6.575c.279.27.236.71-.043.982l-6.763 6.574c-.204.2-.195.258-.462.15-.266-.107-.123-.36-.123-.64V10.43C10.4 10.545.78 11.462 0 15",
    fill: "#5D5D5D"
  })));
}

export default SvgSwipeNext;